import axios from 'axios';

export const BACKEND_URL = 'https://barcabrones-backend.onrender.com';
const API = `${BACKEND_URL}/api`;

// URL do servidor da Tesouraria (Clube)
export const CLUB_BACKEND_URL = 'https://tesourariacabrones.onrender.com';
const CLUB_API = `${CLUB_BACKEND_URL}/api`;

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// NOVA FUNÇÃO: Pega a chave exclusiva da Tesouraria
const getClubHeaders = () => {
  const token = localStorage.getItem('club_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// --- ROTAS DO SISTEMA DO BAR (INTACTAS) ---
export const api = {
  products: {
    getAll: () => axios.get(`${API}/products`, { headers: getHeaders() }),
    create: (data) => axios.post(`${API}/products`, data, { headers: getHeaders() }),
    update: (id, data) => axios.put(`${API}/products/${id}`, data, { headers: getHeaders() }),
    delete: (id) => axios.delete(`${API}/products/${id}`, { headers: getHeaders() }),
    getLowStock: () => axios.get(`${API}/products/low-stock`, { headers: getHeaders() }),
    getMovements: (id) => axios.get(`${API}/products/${id}/movements`, { headers: getHeaders() }),
  },
  stockAdjustments: {
    create: (data) => axios.post(`${API}/stock-adjustments`, data, { headers: getHeaders() }),
  },
  customers: {
    getAll: () => axios.get(`${API}/customers`, { headers: getHeaders() }),
    create: (data) => axios.post(`${API}/customers`, data, { headers: getHeaders() }),
    update: (id, data) => axios.put(`${API}/customers/${id}`, data, { headers: getHeaders() }),
    delete: (id) => axios.delete(`${API}/customers/${id}`, { headers: getHeaders() }),
    getHistory: (id) => axios.get(`${API}/customers/${id}/history`, { headers: getHeaders() }),
    adjustBalance: (id, data) => axios.put(`${API}/customers/${id}/adjust-balance`, data, { headers: getHeaders() }),
  },
  sales: {
    getAll: () => axios.get(`${API}/sales`, { headers: getHeaders() }),
    create: (data) => axios.post(`${API}/sales`, data, { headers: getHeaders() }),
    getPending: () => axios.get(`${API}/sales/pending`, { headers: getHeaders() }),
    updateStatus: (id, status) => axios.put(`${API}/sales/${id}/status?status=${status}`, {}, { headers: getHeaders() }),
  },
  payments: {
    create: (data) => axios.post(`${API}/payments`, data, { headers: getHeaders() }),
  },
  reports: {
    getDashboard: (params) => axios.get(`${API}/reports/dashboard`, { headers: getHeaders(), params }),
    getTopProducts: () => axios.get(`${API}/reports/top-products`, { headers: getHeaders() }),
    getTopCustomers: () => axios.get(`${API}/reports/top-customers`, { headers: getHeaders() }),
    exportProducts: () => axios.get(`${API}/reports/export/products`, { headers: getHeaders() }),
    exportSales: () => axios.get(`${API}/reports/export/sales`, { headers: getHeaders() }),
    exportCustomers: () => axios.get(`${API}/reports/export/customers`, { headers: getHeaders() }),
    exportCustomerPDF: (id) => axios.get(`${API}/reports/export/customer/${id}/pdf`, { headers: getHeaders(), responseType: 'blob' }),
  },
  users: {
    getAll: () => axios.get(`${API}/users`, { headers: getHeaders() }),
    create: (data) => axios.post(`${API}/users`, data, { headers: getHeaders() }),
    update: (id, data) => axios.put(`${API}/users/${id}`, data, { headers: getHeaders() }),
    delete: (id) => axios.delete(`${API}/users/${id}`, { headers: getHeaders() }),
  },
  settings: {
    get: () => axios.get(`${API}/settings`, { headers: getHeaders() }),
    update: (data) => axios.put(`${API}/settings`, data, { headers: getHeaders() }),
  },
  churrasqueiros: {
    getAll: () => axios.get(`${API}/churrasqueiros`, { headers: getHeaders() }),
    create: (data) => axios.post(`${API}/churrasqueiros`, data, { headers: getHeaders() }),
    update: (id, data) => axios.put(`${API}/churrasqueiros/${id}`, data, { headers: getHeaders() }),
    delete: (id) => axios.delete(`${API}/churrasqueiros/${id}`, { headers: getHeaders() }),
  },
  dinners: {
    getAll: () => axios.get(`${API}/dinners`, { headers: getHeaders() }),
    create: (data) => axios.post(`${API}/dinners`, data, { headers: getHeaders() }),
    getById: (id) => axios.get(`${API}/dinners/${id}`, { headers: getHeaders() }),
    markPaid: (id, participantIndex) => axios.put(`${API}/dinners/${id}/participant/${participantIndex}/paid`, {}, { headers: getHeaders() }),
    delete: (id) => axios.delete(`${API}/dinners/${id}`, { headers: getHeaders() }),
  },
  purchases: {
    getAll: () => axios.get(`${API}/purchases`, { headers: getHeaders() }),
    create: (data) => axios.post(`${API}/purchases`, data, { headers: getHeaders() }),
  },
  suppliers: {
    getAll: () => axios.get(`${API}/suppliers`, { headers: getHeaders() }),
    create: (data) => axios.post(`${API}/suppliers`, data, { headers: getHeaders() }),
    update: (id, data) => axios.put(`${API}/suppliers/${id}`, data, { headers: getHeaders() }),
    delete: (id) => axios.delete(`${API}/suppliers/${id}`, { headers: getHeaders() }),
  },
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/upload`, formData, {
      headers: {
        ...getHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

// --- ROTAS DA TESOURARIA DO CLUBE (NOVAS) ---
export const apiClube = {
  auth: {
    login: (credentials) => axios.post(`${CLUB_API}/auth/login`, credentials),
  },
  members: {
    getAll: () => axios.get(`${CLUB_API}/members`, { headers: getClubHeaders() }),
    create: (data) => axios.post(`${CLUB_API}/members`, data, { headers: getClubHeaders() }),
  },
  dues: {
    getAll: (year) => axios.get(`${CLUB_API}/dues${year ? `?year=${year}` : ''}`, { headers: getClubHeaders() }),
    create: (data) => axios.post(`${CLUB_API}/dues`, data, { headers: getClubHeaders() }),
    update: (id, data) => axios.put(`${CLUB_API}/dues/${id}`, data, { headers: getClubHeaders() }),
  },
  transactions: {
    getAll: (account) => axios.get(`${CLUB_API}/transactions${account ? `?account=${account}` : ''}`, { headers: getClubHeaders() }),
    create: (data) => axios.post(`${CLUB_API}/transactions`, data, { headers: getClubHeaders() }),
    delete: (id) => axios.delete(`${CLUB_API}/transactions/${id}`, { headers: getClubHeaders() }),
  },
  fixedCosts: {
    getAll: () => axios.get(`${CLUB_API}/fixed-costs`, { headers: getClubHeaders() }),
    create: (data) => axios.post(`${CLUB_API}/fixed-costs`, data, { headers: getClubHeaders() }),
  }
};
